import { requireNativeComponent } from 'react-native';

const COMVideoView: any = requireNativeComponent('COMVideoView');
export default COMVideoView;
